var styleDataHash = 'a366eb79';  
export const injectCss = (() => {
  var css = `.BREeK{box-sizing:border-box;height:29px;margin:0 auto;max-width:100%;padding-top:14px;width:100%}.Hhqkf{padding-top:11px}.ixFlP{display:block;stroke:currentColor;stroke-width:1;shape-rendering:crispEdges}._0H7Kv,._7qQTT,.jadp7,.t-2Qs{height:100%}._7qQTT{stroke-dasharray:4 4}._0H7Kv{stroke-dasharray:1 5}.yO8Z8{width:10%}.xWlva{width:40%}.grqiU{width:100%}.QcWjo{margin-right:auto}._5MBF-{margin:0 auto}.YkyI5{margin-left:auto}.F7RE1{height:100%}.F7RE1 .hn47y{height:1px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





